module.exports = "/_next/static/images/f86d941e4e97468a6c895ab483a28b79-apple-store.svg";